import React from "react";

export default function Message() {
  return (
    <div className="box-messages">
      <div className="section-container">
        <div className="row justify-center">
          <div className="col-12">
            <div className="heading-section wow fadeInUp style-2 text-center">
              <h6>Get In Touch</h6>
              <div className="main-title">
                Send Us{" "}
                <span className="animation-text tf-color">Messages</span>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="widget-reply wow fadeInUp">
              <form className="comment-form">
                <div className="columns flex justify-between gap20">
                  <fieldset className="name">
                    <input
                      type="text"
                      placeholder="Full Name"
                      className="mb-20"
                      name="name"
                      tabIndex={2}
                      aria-required="true"
                      required
                    />
                  </fieldset>
                  <fieldset className="email">
                    <input
                      type="email"
                      id="email"
                      placeholder="Email Address"
                      className="mb-20"
                      name="email"
                      tabIndex={2}
                      aria-required="true"
                      required
                    />
                  </fieldset>
                </div>
                <div className="columns flex justify-between gap20">
                  <fieldset className="website">
                    <input
                      type="text"
                      placeholder="Website"
                      className="mb-20"
                      name="website"
                      tabIndex={2}
                      aria-required="true"
                      required
                    />
                  </fieldset>
                  <fieldset>
                    <select name="subject" id="subject">
                      <option value="Subject">Subject</option>
                      <option value="AI">AI</option>
                      <option value="Media">Media</option>
                    </select>
                  </fieldset>
                </div>
                <fieldset className="message">
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    placeholder="Message"
                    className="mb-20"
                    tabIndex={4}
                    aria-required="true"
                    required
                  />
                </fieldset>
                <div className="text-center">
                  <button className="" type="submit">
                    Send Us Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}